import { Injectable } from '@angular/core';
import { UpdateAuthUser } from '@app/auth/actions/auth';
import { UserDataService } from '@app/core/services/user-data.service';
import {
  LayoutActionTypes,
  ToggleFullScreen,
  UpdateFullScreenModeFailed
} from '@app/pcs/actions/layout';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class LayoutEffects {

  updateFullScreenMode$ = createEffect(() => this.actions$.pipe(
    ofType<ToggleFullScreen>(LayoutActionTypes.ToggleFullScreen),
    switchMap(() => this.userDataService.updateFullScreenMode()
      .pipe(
        switchMap(user => [new UpdateAuthUser(user)]),
        catchError(err => of(new UpdateFullScreenModeFailed(err)))
      ))
  ));

  constructor(private actions$: Actions,
    private userDataService: UserDataService) {
  }
}
